import React from "react";
import { Grid, Row, Col } from "react-flexbox-grid";
import { FooterNavigation } from "components/FooterNavigation";
import metadata from "../../metadata.json"

export default ({ children }) => (
  <React.Fragment>
    <footer className="pv-footer hidden-xs">
      <Grid>
        <Row>
          <Col md={12}>
            <FooterNavigation />
          </Col>
        </Row>
      </Grid>
    </footer>
    <div className="copyright-footer">
      <Grid>
        <Row>
          <Col md={12}>
            <p className="text-center">
              Copyright © Paws for A Purpose {new Date().getFullYear()}. Version{" "} 
              1.{metadata.bigVersion}.{metadata.smallVersion}
            </p>
          </Col>
        </Row>
      </Grid>
    </div>
  </React.Fragment>
);
